import axios from "axios";

export default {
    BuyingFuel: {
        async Create(data) {
            return await axios.post("/api/storage/CreateBuyingFuel", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/UpdateBuyingFuel", data);
        },
        async Delete(id) {
            return await axios.post(`/api/storage/DeleteBuyingFuel?id=${id}`);
        },
        async Get(id) {
            return await axios.get(`/api/storage/GetBuyingFuel?id=${id}`);
        },
        async Datatable(data) {
            return await axios.post("/api/storage/GetTableBuyingFuel", data);
        },
        async Statistics(data) {
            return await axios.post("/api/storage/GetBuyingFuelStatistics", data);
        },
        async ExcelReport(data) {
            return await axios.post("/api/storage/GetBuyingFuelExcelReport", data);
        },
        async GetEmployeeCurrentAssignment(employeeId) {
            return await axios.get(`/api/storage/GetEmployeeCurrentAssignment/${employeeId}`);
        },
        async CreateOrUpdate(editing, data) {
            return editing ? await this.Update(data) : await this.Create(data);
        },
    },
    FuelStorage: {
        async Create(data) {
            return await axios.post("/api/storage/create/fuelstorage", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/update/fuelstorage", data);
        },
        async Delete(id) {
            return await axios.get(`/api/storage/delete/fuelstorage/${id}`);
        },
        async Get(id) {
            return await axios.get(`/api/storage/get/fuelstorage/${id}`);
        },
        async List(data = {}) {
            return await axios.post("/api/storage/list/fuelstorage", data);
        },
        async Datatable(data) {
            return await axios.post("/api/storage/datatable/fuelstorage", data);
        },
        async CreateOrUpdate(editing, data) {
            if (editing) {
                return await this.Update(data);
            } else {
                return await this.Create(data);
            }
        },
        async Balance(data) {
            return await axios.post("/api/storage/stock/balance", data);
        },
        async BranchesWithFuelStorage() {
            return await axios.get("/api/storage/list/branches-with-fuelstorage");
        },
    },
    FuelStorageEmployee: {
        async List(fuelStorageId) {
            if (!fuelStorageId) {
                return await axios.get("/api/storage/list/fuelstorageemployee");
            }
            return await axios.get(`/api/storage/list/fuelstorageemployee/${fuelStorageId}`);
        },
        async Manage(data) {
            return await axios.post("/api/storage/manage/fuelstorageemployee", data);
        },
    },
    ActiveEmployee: {
        async Search(search) {
            return await axios.get(`/api/hroperations/get/activeemployees/search/${search}`);
        },
    },
    FuelStorageTransaction: {
        async Create(data) {
            return await axios.post("/api/storage/create/fuelstoragetransaction", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/update/fuelstoragetransaction", data);
        },
        async Delete(id) {
            return await axios.get(`/api/storage/delete/fuelstoragetransaction/${id}`);
        },
        async Get(id) {
            return await axios.get(`/api/storage/get/fuelstoragetransaction/${id}`);
        },
        async List() {
            return await axios.post("/api/storage/list/fuelstoragetransaction");
        },
        async Datatable(data) {
            return await axios.post("/api/storage/datatable/fuelstoragetransaction", data);
        },
        async CreateOrUpdate(editing, data) {
            if (editing) {
                return await this.Update(data);
            } else {
                return await this.Create(data);
            }
        },
        async Transfer(data) {
            return await axios.post("/api/storage/transfer", data);
        },
        async ConfirmTransfer(data) {
            return await axios.post("/api/storage/Tranfer/Confirm", data);
        },
        async GetListWaitingMyConfirm() {
            return await axios.post("/api/storage/Transfer/WaitingConfirm");
        },
    },
    FuelStorageTransactionDetail: {
        async Create(data) {
            return await axios.post("/api/storage/create/fuelstoragetransactiondetail", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/update/fuelstoragetransactiondetail", data);
        },
        async Delete(id) {
            return await axios.get(`/api/storage/delete/fuelstoragetransactiondetail/${id}`);
        },
        async Get(id) {
            return await axios.get(`/api/storage/get/fuelstoragetransactiondetail/${id}`);
        },
        async List() {
            return await axios.post("/api/storage/list/fuelstoragetransactiondetail");
        },
        async Datatable(data) {
            return await axios.post("/api/storage/datatable/fuelstoragetransactiondetail", data);
        },
        async CreateOrUpdate(editing, data) {
            if (editing) {
                return await this.Update(data);
            } else {
                return await this.Create(data);
            }
        },
    },
    FuelOrderDetail: {
        GetByFuelOrderId(fuelOrderId) {
            return axios.get(`/api/storage/get/fuelorderwithfuelorderid/${fuelOrderId}`);
        },
        Create(data) {
            return axios.post("/api/storage/create/fuelorderdetail", data);
        },
        Update(data) {
            return axios.post("/api/storage/update/fuelorderdetail", data);
        },
    },
    IntegratedStorageClass: {
        async Create(data) {
            return await axios.post("/api/storage/create/integratedstorageclass", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/update/integratedstorageclass", data);
        },
        async Delete(id) {
            return await axios.get(`/api/storage/delete/integratedstorageclass/${id}`);
        },
        async Get(id) {
            return await axios.get(`/api/storage/get/integratedstorageclass/${id}`);
        },
        async List() {
            return await axios.get("/api/storage/list/integratedstorageclass");
        },
        async Datatable(data) {
            return await axios.post("/api/storage/datatable/integratedstorageclass", data);
        },
        async CreateOrUpdate(editing, data) {
            if (editing) {
                return await this.Update(data);
            } else {
                return await this.Create(data);
            }
        },
    },
    FuelStorageClass: {
        async Create(data) {
            return await axios.post("/api/storage/create/fuelstorageclass", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/update/fuelstorageclass", data);
        },
        async Delete(id) {
            return await axios.get(`/api/storage/delete/fuelstorageclass/${id}`);
        },
        async Get(id) {
            return await axios.get(`/api/storage/get/fuelstorageclass/${id}`);
        },
        async List() {
            return await axios.get("/api/storage/list/fuelstorageclass");
        },
        async Datatable(data) {
            return await axios.post("/api/storage/datatable/fuelstorageclass", data);
        },
        async CreateOrUpdate(editing, data) {
            if (editing) {
                return await this.Update(data);
            } else {
                return await this.Create(data);
            }
        },
    },
    Data: {
        async GetFuelStorageEmployeeJobEnumList() {
            return await axios.get("/api/storage/select/list/fuelstorageemployeejob");
        },
        async GetFuelStorageTypeEnumList() {
            return await axios.get("/api/storage/select/list/fuelstoragetype");
        },
        async GetFuelStorageMaterialEnumList() {
            return await axios.get("/api/storage/select/list/fuelstoragematerial");
        },
        async GetFuelStorageMobilityStatusEnumList() {
            return await axios.get("/api/storage/select/list/fuelstoragemobilitystatus");
        },
        async GetFuelTransactionTypeEnumList() {
            return await axios.get("/api/storage/select/list/fueltransactiontype");
        },
        async GetFuelTransactionStatusEnumList() {
            return await axios.get("/api/storage/select/list/fueltransactionstatus");
        },
    },
    FuelSupplier: {
        async Create(data) {
            return await axios.post("/api/storage/create/fuelsupplier", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/update/fuelsupplier", data);
        },
        async Delete(id) {
            return await axios.get(`/api/storage/delete/fuelsupplier/${id}`);
        },
        async Get(id) {
            return await axios.get(`/api/storage/get/fuelsupplier/${id}`);
        },
        async List() {
            return await axios.get("/api/storage/list/fuelsupplier");
        },
        async Datatable(data) {
            return await axios.post("/api/storage/datatable/fuelsupplier", data);
        },
        async CreateOrUpdate(editing, data) {
            if (editing) {
                return await this.Update(data);
            } else {
                return await this.Create(data);
            }
        },
    },
    FuelOrder: {
        async Datatable(data) {
            return await axios.post("/api/storage/datatable/fuelorder", data);
        },
        async Create(data) {
            return await axios.post("/api/storage/create/fuelorder", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/update/fuelorder", data);
        },
        async Delete(data) {
            const response = await axios.get(`/api/storage/delete/fuelorder/${data}`);
            return response;
        },
        async CreateMultiple(data) {
            return await axios.post("/api/storage/create/fuelorder/multiple", data);
        },
        async List(isListForOrder = true) {
            return await axios.get(`/api/storage/list/fuelorder/${isListForOrder}`);
        },
        async ListForDocumentation() {
            return await axios.get("/api/storage/list/fuelorderfordocumentation");
        },
        async Get(orderId) {
            return await axios.get(`/api/storage/get/fuelorder/${orderId}`);
        },
        async Confirm(id) {
            return await axios.post(`/api/storage/confirm/fuelorderstatus/${id}`);
        },
        async Cancel(id) {
            return await axios.post(`/api/storage/cancel/fuelorderstatus/${id}`);
        },
        async GetFuelOrderExcelReport(data) {
            return await axios.post("/api/storage/report/excel/fuelorder", data);
        },
        // async ChangeStatus(payload) {
        //     return await axios.post('/api/storage/update/fuelorderstatus', payload)
        // },
    },
    FuelStorageClass: {
        async Create(data) {
            return await axios.post("/api/storage/create/fuelstorageclass", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/update/fuelstorageclass", data);
        },
        async Delete(id) {
            return await axios.get(`/api/storage/delete/fuelstorageclass/${id}`);
        },
        async Get(id) {
            return await axios.get(`/api/storage/get/fuelstorageclass/${id}`);
        },
        async List() {
            return await axios.get("/api/storage/list/fuelstorageclass");
        },
        async Datatable(data) {
            return await axios.post("/api/storage/datatable/fuelstorageclass", data);
        },
        async CreateOrUpdate(editing, data) {
            return editing ? this.Update(data) : this.Create(data);
        },
    },
    FuelStorageReport: {
        async GetFuelStorageStockLevelReport(data) {
            return await axios.post("/api/storage/reports/stock-level", data);
        },
        async GetOutputReport(data) {
            return await axios.post("/api/storage/reports/output", data);
        },
    },
    ExcelReport: {
        async ExportFuelStorageTransactionReport(data) {
            return await axios.post("/api/storage/report/excel/fuelstoragetransaction", data);
        },
        async ExportFuelStorageStockStatusReport(data) {
            return await axios.post("/api/storage/report/excel/fuelstoragestock", data);
        },
    },
    Information: {
        async VehicleLastKm(plateid) {
            return await axios.get(`/api/storage/get/vehiclelastkm/${plateid}`);
        },
        async TrailerLastAcCounter(plateid) {
            return await axios.get(`/api/storage/get/trailerlastaccounter/${plateid}`);
        },
        async VehicleLastAcCounter(plateid) {
            return await axios.get(`/api/storage/get/vehiclelastaccounter/${plateid}`);
        },
    },
    FuelStorageCreditCardInformation: {
        async Create(data) {
            return await axios.post("/api/storage/FuelStorageCreditCardInformation/Create", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/FuelStorageCreditCardInformation/Update", data);
        },
        async Delete(id) {
            // Delete işlemi backend'de HttpPost olarak tanımlı ve query string bekliyor
            return await axios.post(`/api/storage/FuelStorageCreditCardInformation/Delete?id=${id}`);
        },
        async Get(id) {
            return await axios.get(`/api/storage/FuelStorageCreditCardInformation/Get/${id}`);
        },
        async List() {
            return await axios.get("/api/storage/FuelStorageCreditCardInformation/List");
        },
        async Table(data) {
            return await axios.post("/api/storage/FuelStorageCreditCardInformation/Table", data);
        },
        async CreateOrUpdate(editing, data) {
            return editing ? await this.Update(data) : await this.Create(data);
        },
    },

    FuelStorageRefineryPrice: {
        async Create(data) {
            return await axios.post("/api/storage/FuelStorageRefineryPrice/Create", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/FuelStorageRefineryPrice/Update", data);
        },
        async Delete(id) {
            return await axios.post(`/api/storage/FuelStorageRefineryPrice/Delete?id=${id}`);
        },
        async Get(id) {
            return await axios.get(`/api/storage/FuelStorageRefineryPrice/Get/${id}`);
        },
        async List() {
            return await axios.get("/api/storage/FuelStorageRefineryPrice/List");
        },
        async Table(data) {
            return await axios.post("/api/storage/FuelStorageRefineryPrice/Table", data);
        },
        async CreateOrUpdate(editing, data) {
            return editing ? await this.Update(data) : await this.Create(data);
        },
    },

    FuelStorageSupplierAgreement: {
        async Create(data) {
            return await axios.post("/api/storage/FuelStorageSupplierAgreement/Create", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/FuelStorageSupplierAgreement/Update", data);
        },
        async Delete(id) {
            return await axios.post(`/api/storage/FuelStorageSupplierAgreement/Delete?id=${id}`);
        },
        async Get(id) {
            return await axios.get(`/api/storage/FuelStorageSupplierAgreement/Get/${id}`);
        },
        async List() {
            return await axios.get("/api/storage/FuelStorageSupplierAgreement/List");
        },
        async Table(data) {
            return await axios.post("/api/storage/FuelStorageSupplierAgreement/Table", data);
        },
        async CreateOrUpdate(editing, data) {
            return editing ? await this.Update(data) : await this.Create(data);
        },
    },

    FuelStorageSupplierIskonto: {
        async Create(data) {
            return await axios.post("/api/storage/FuelStorageSupplierIskonto/Create", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/FuelStorageSupplierIskonto/Update", data);
        },
        async Delete(id) {
            return await axios.post(`/api/storage/FuelStorageSupplierIskonto/Delete?id=${id}`);
        },
        async Get(id) {
            return await axios.get(`/api/storage/FuelStorageSupplierIskonto/Get/${id}`);
        },
        async List() {
            return await axios.get("/api/storage/FuelStorageSupplierIskonto/List");
        },
        async Table(data) {
            return await axios.post("/api/storage/FuelStorageSupplierIskonto/Table", data);
        },
        async CreateOrUpdate(editing, data) {
            return editing ? await this.Update(data) : await this.Create(data);
        },
        async GetBySupplier(supplierId) {
            return await axios.get(`/api/storage/FuelStorageSupplierIskonto/GetBySupplier/${supplierId}`);
        },
        async BulkCreateOrUpdate(data) {
            return await axios.post("/api/storage/FuelStorageSupplierIskonto/BulkCreateOrUpdate", data);
        },
    },
    FuelStorageShift: {
        async Start(data) {
            return await axios.post("/api/storage/Shift/Start", data);
        },
        async End(data) {
            return await axios.post("/api/storage/Shift/End", data);
        },
        async GetActiveStatus() {
            return await axios.get("/api/storage/Shift/ActiveStatus");
        },
        async TableAll(data) {
            return await axios.post("/api/storage/Shift/Table/All", data);
        },
        async TableCurrentUser(data) {
            return await axios.post("/api/storage/Shift/Table/CurrentUser", data);
        },
        async ExportExcel() {
            return await axios.get("/api/storage/Shift/ExportExcel");
        },
        async GetPhotos(shiftId) {
            return await axios.get(`/api/storage/Shift/GetPhotos/${shiftId}`);
        },
    },
    FuelStoragePump: {
        async Create(data) {
            return await axios.post("/api/storage/FuelStoragePump/Create", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/FuelStoragePump/Update", data);
        },
        async Delete(id) {
            return await axios.post(`/api/storage/FuelStoragePump/Delete?id=${id}`);
        },
        async GetByStorage(fuelStorageId) {
            return await axios.get(`/api/storage/FuelStoragePump/GetByStorage/${fuelStorageId}`);
        },
        async GetByBranch(branchId) {
            return await axios.get(`/api/storage/FuelStoragePump/GetByBranch/${branchId}`);
        },
        async GetByCurrentUser() {
            return await axios.get("/api/storage/FuelStoragePump/GetByCurrentUser");
        },
    },
    FuelConsumptionReport: {
        async GetByPlate(data) {
            return await axios.post("/api/storage/reports/fuel-consumption/by-plate", data);
        },
        async GetByDutyLocation(data) {
            return await axios.post("/api/storage/reports/fuel-consumption/by-duty-location", data);
        },
        async GetByBranch(data) {
            return await axios.post("/api/storage/reports/fuel-consumption/by-branch", data);
        },
        async GetCompanyTotal(data) {
            return await axios.post("/api/storage/reports/fuel-consumption/company-total", data);
        },
        async ExportByPlateExcel(data) {
            return await axios.post("/api/storage/reports/fuel-consumption/by-plate/excel", data);
        },
        async ExportByDutyLocationExcel(data) {
            return await axios.post("/api/storage/reports/fuel-consumption/by-duty-location/excel", data);
        },
        async ExportByBranchExcel(data) {
            return await axios.post("/api/storage/reports/fuel-consumption/by-branch/excel", data);
        },
        async ExportCompanyTotalExcel(data) {
            return await axios.post("/api/storage/reports/fuel-consumption/company-total/excel", data);
        },
    },
    DrainingFuelFromVehicle: {
        async Create(data) {
            return await axios.post("/api/storage/CreateDrainingFuelFromVehicle", data);
        },
        async Update(data) {
            return await axios.post("/api/storage/UpdateDrainingFuelFromVehicle", data);
        },
        async Delete(id) {
            return await axios.post(`/api/storage/DeleteDrainingFuelFromVehicle?id=${id}`);
        },
        async Datatable(data) {
            return await axios.post("/api/storage/GetDatatableDrainingFuelFromVehicle", data);
        },
        async Statistics(data) {
            return await axios.post("/api/storage/GetDrainingFuelFromVehicleStatistics", data);
        },
    },
};
